var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / KR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 4.66666667,
    cy: 4.66666667,
    r: 4.66666667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-KR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-9",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.333333, 5.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#E01B41",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.18713936e-14,5.33333333 C1.3333333,6.58333331 3.33333333,7.33333333 4.66666667,5.33333333 C6,3.33333333 8.66666667,3.33333326 9.33333333,5.33333333 C10,7.33333341 9.33333333,9.33333333 9.33333333,9.33333333 L-2.18713936e-14,9.33333333 C-2.18713936e-14,9.33333333 -1.3333333,4.08333336 -2.18713936e-14,5.33333333 Z",
    id: "Rectangle-277",
    stroke: "none",
    fill: "#0E4B9C",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22.7969332,12.7695107 L23.3688743,13.099721 C23.5297989,13.1926309 23.5842939,13.399516 23.4897352,13.5632965 L21.8307729,16.4367035 C21.7365979,16.5998193 21.5366809,16.6607058 21.3688743,16.5638227 L20.7969332,16.2336123 C20.6360086,16.1407024 20.5815137,15.9338173 20.6760724,15.7700368 L22.3350346,12.8966299 C22.4292096,12.733514 22.6291267,12.6726275 22.7969332,12.7695107 Z M5.66496538,12.8966299 L7.32392763,15.7700368 C7.4181026,15.9331526 7.37087332,16.1367292 7.2030668,16.2336123 L6.63112566,16.5638227 C6.4702011,16.6567325 6.2637858,16.600484 6.16922709,16.4367035 L4.51026484,13.5632965 C4.41608986,13.4001807 4.46331915,13.1966042 4.63112566,13.099721 L5.2030668,12.7695107 C5.36399136,12.6766008 5.57040666,12.7328494 5.66496538,12.8966299 Z M21.0648824,11.7695107 L21.6368235,12.099721 C21.7977481,12.1926309 21.8522431,12.399516 21.7576844,12.5632965 L20.0987221,15.4367035 C20.0045471,15.5998193 19.80463,15.6607058 19.6368235,15.5638227 L19.0648824,15.2336123 C18.9039578,15.1407024 18.8494629,14.9338173 18.9440216,14.7700368 L20.6029838,11.8966299 C20.6971588,11.733514 20.8970759,11.6726275 21.0648824,11.7695107 Z M7.39701618,11.8966299 L9.05597843,14.7700368 C9.15015341,14.9331526 9.10292412,15.1367292 8.93511761,15.2336123 L8.36317647,15.5638227 C8.20225191,15.6567325 7.99583661,15.600484 7.90127789,15.4367035 L6.24231564,12.5632965 C6.14814067,12.4001807 6.19536995,12.1966042 6.36317647,12.099721 L6.93511761,11.7695107 C7.09604217,11.6766008 7.30245747,11.7328494 7.39701618,11.8966299 Z M8.36317647,4.43617734 L8.93511761,4.76638771 C9.09604217,4.85929755 9.15053715,5.06618271 9.05597843,5.22996321 L7.39701618,8.10337012 C7.30284121,8.26648596 7.10292412,8.32737246 6.93511761,8.23048932 L6.36317647,7.90027896 C6.20225191,7.80736912 6.14775693,7.60048395 6.24231564,7.43670345 L7.90127789,4.56329655 C7.99545287,4.40018071 8.19536995,4.3392942 8.36317647,4.43617734 Z M20.0987221,4.56329655 L21.7576844,7.43670345 C21.8518593,7.59981929 21.80463,7.80339582 21.6368235,7.90027896 L21.0648824,8.23048932 C20.9039578,8.32339917 20.6975425,8.26715062 20.6029838,8.10337012 L18.9440216,5.22996321 C18.8498466,5.06684737 18.8970759,4.86327085 19.0648824,4.76638771 L19.6368235,4.43617734 C19.7977481,4.3432675 20.0041634,4.39951605 20.0987221,4.56329655 Z M6.63112566,3.43617734 L7.2030668,3.76638771 C7.36399136,3.85929755 7.41848634,4.06618271 7.32392763,4.22996321 L5.66496538,7.10337012 C5.5707904,7.26648596 5.37087332,7.32737246 5.2030668,7.23048932 L4.63112566,6.90027896 C4.4702011,6.80736912 4.41570612,6.60048395 4.51026484,6.43670345 L6.16922709,3.56329655 C6.26340206,3.40018071 6.46331915,3.3392942 6.63112566,3.43617734 Z M21.8307729,3.56329655 L23.4897352,6.43670345 C23.5839101,6.59981929 23.5366809,6.80339582 23.3688743,6.90027896 L22.7969332,7.23048932 C22.6360086,7.32339917 22.4295933,7.26715062 22.3350346,7.10337012 L20.6760724,4.22996321 C20.5818974,4.06684737 20.6291267,3.86327085 20.7969332,3.76638771 L21.3688743,3.43617734 C21.5297989,3.3432675 21.7362142,3.39951605 21.8307729,3.56329655 Z",
    id: "Rectangle-278",
    fill: "#262626",
    opacity: 0.75,
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/KR.800ac2fcd24e6ce7aa254730aacadab9.svg";
export { ForwardRef as ReactComponent };